module.exports = __webpack_public_path__ + "img/search-header-with-nav-chevy.6287b66d.png";